<template>
    <div class="iframe_wrapper" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.8)" style="height: 100%;">
        <Order ref="myOrder" @pay="pay" v-show='orderShow' />
        <Payment :show='payShow' @back='backToOrder'/>
    </div>
</template>

<script>
    import Order from '../../components/Order.vue';
    import Payment from '../../components/Payment.vue'
    export default {
        name: 'iframeOrder',
        provide() {
            let self = this
            return {
                appOverFlow() {
                    
                },
                clearAddBuyValidState () {
                    
                },
                popOverShow (x) {
                    
                },
                paymentShow (x) {
                    self.payShow = x
                },
                orderShow (x) {
                    self.orderShow = x
                },
                clearRenewBuyValidState () {
                    
                },
                seatInstance () {
                    
                }
            }
        },
        data: () => {
            return {
                orderShow: false,
                payShow: false,
                loading: true
            }
        },
        computed: {

        },
        components: {
            Order,
            Payment
        },
        watch: {

        },
        methods: {
            init() {
                const DZH_CONFIG = {
                    110: 'webtq10',
                    125: 'webtq10',
                    130: 'webwh11',
                    131: 'webwh11',
                }
                let url = '/api/Order/NeiPan'
                let data = {
                    IsQuarter: false,
                    buynum: 1,
                    identityType: 2,
                    isDanAuthorization: false,
                    isMonth: false,
                    isjg:-1,
                    ismajor:-1,
                    morderid: "",
                    dzh: DZH_CONFIG[this.$route.params.id],
                    productId: this.$route.params.id,
                    subids: "",
                    userCode: "",
                    userEdate: "",
                    userSdate: "",
                    xzh: ""
                }
                if (this.$route.params.id == '122' || this.$route.params.id == '124') {
                    //paytype  1-按月支付 2-按季支付 3-按年支付
                    if (this.$route.query.paytype == '1') {
                        data.isMonth = true
                    } else if (this.$route.query.paytype == '2') {
                        data.IsQuarter = true
                    }
                }
                let {wh10Account,wh10Phone,isWh10TryAccount,isWh10TryAccountDate} = this.getValidData()
                this.$store.commit('newbuy/setInterface', {
                    url,
                    data
                })
                this.$axios({
                    url: url,
                    method: "post",
                    data
                })
                .then(res => {
                    if (!res.data.status) {
                        this.loading = false
                        return this.$market.alert({
                            content: res.data.message
                        })
                    }
                    res.data.wh10Account = wh10Account
                    res.data.wh10Phone = wh10Phone
                    
                    //如果是wh10验证过手机号之后进入购买页面的，购买页面上的手机号不允许修改，增加一个标识进行限制
                    if (wh10Phone) {
                        res.data.wh10LockPhone = true
                    }
                    res.data.isWh10TryAccount = isWh10TryAccount
                    res.data.isWh10TryAccountDate = isWh10TryAccountDate
                    res.data.isMonth = data.isMonth
                    res.data.IsQuarter = data.IsQuarter
                    res.data.hasHistory = false
                    this.$store.commit('setOrderInfo', res)
                    this.initOrder()
                    this.$nextTick(() => {
                        this.loading = false
                        this.orderShow = true
                        
                    })
                }).catch(e => {
                    this.loading = false
                })
            },
            initOrder () {
                this.$refs.myOrder.DataIinitialization(this.$store.state.orderInfo);
            },
            getValidData () {
                let wh10Account,wh10Phone,isWh10TryAccount,isWh10TryAccountDate 
                if (this.$route.query.validdata) {
                    let data =  JSON.parse(decodeURIComponent(atob(this.$route.query.validdata)))
                    wh10Account = data.account
                    wh10Phone = data.phone
                    isWh10TryAccount = data.isTransAccount
                    isWh10TryAccountDate = data.edate

                }
                return {wh10Account,wh10Phone,isWh10TryAccount,isWh10TryAccountDate}
            },
            pay() {
                this.orderShow = false
                this.payShow = true
            },
            backToOrder() {
                this.payShow = false;
                this.orderShow = true
            }
        },
        mounted() {
            this.init()
        },
        created () {
            this.$store.commit('setInIframe', true)
        }
    }
</script>

<style scoped>
/* .iframe_wrapper >>> .orderBuy  {
    width: 100% !important;
} */
</style>